$(document).ready(function() {

    console.log("this init the pride is run");
  var TotalSlideNum = 8;    
 


  $('input[type="radio"]').click(function(){
        var inputValue = $(this).attr("value");
        var targetBox = $("#pride-" + inputValue);
        $(".description").not(targetBox).hide();
        $(targetBox).show();

   
    });  
   
    $(".btnprev").click(function(){
       var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
       var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
       console.log("on slideNum", slideNum)
        if (slideNum > 1 && slideNum <= 8){
            var cslideNum  = slideNum - 1  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#pride-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        
        }else if (slideNum == 1 ){
            var cslideNum  = 8  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);
            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#pride-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });
    $(".btnnext").click(function(){
        var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
        var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
     
       console.log("on slideNum", slideNum)
        if (slideNum > 0 && slideNum < 8){
            var cslideNum  = slideNum + 1 ;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#pride-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        }else if (slideNum = TotalSlideNum ){
            var cslideNum  = 1;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#pride-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });


})

